import { AnyObject } from '@store/types';
import isNil from 'lodash/isNil';
import proschet from 'proschet';
import { format } from 'date-fns/format';
import { Nullable } from 'chaika-common-types';

import { assertIsDefined } from '@utils/assertIsDefined';

export interface FormatterParams {
    precision?: number;
    date?: string;
    declensions?: string[];
}

export class Formatter {
    protected params: FormatterParams;

    protected getDeclension: (value: string) => string;

    constructor(params: FormatterParams = {}) {
        this.params = params;
        this.getDeclension = proschet(params.declensions);
    }

    public format(value: string): string {
        let result = value;

        const formatters = ['precision', 'date', 'declensions'];

        for (const item of formatters) {
            if (!isNil((this.params as AnyObject)[item])) {
                result = (this as AnyObject)[item](result);
            }
        }

        return result;
    }

    protected precision(value: string): string {
        return Number(value).toFixed(this.params.precision);
    }

    protected date(value: string): Nullable<string> {
        if (value === '') {
            return null;
        }

        assertIsDefined(this.params.date, 'Date formatter runs only when the date format param is set');
        return format(new Date(value), this.params.date);
    }

    protected declensions(value: string): string {
        const declension = this.getDeclension(value.replace('.', ','));
        return [value, declension].join(' ');
    }
}
